export const signatureStyle = {
  fontFamily: 'Dancing Script, cursive',
  fontWeight: '700',
  letterSpacing: '2px',
  fontSize: '23px',
};
